import { Routes, Route } from "react-router-dom";
import { SITE_ORIGIN } from "../../siteConfig";

import PuneNavbar from "../../branchPages/puneBranch/pNavbar";
import PuneFooter from "../../branchPages/puneBranch/pFooter";

import Pune from "../../branchPages/puneBranch/puneBranch";
import PuneBranch from "../../separatePages/puneBranch";
import AboutPune from "../../branchPages/puneBranch/pAbout";
import HairTransplantInIndiaPune from "../../branchPages/puneBranch/HTindia/htinIndia.jsx";
import HairTransplantCostPune from "../../branchPages/puneBranch/HTindia/HTcostinIndia.jsx";
import HairTransplantSurgeryPune from "../../branchPages/puneBranch/HTindia/HTsurgeryinIndia.jsx";
import AboutHairTransplantPune from "../../branchPages/puneBranch/treatments/aboutHT.jsx";
import MaleHairTransplantPune from "../../branchPages/puneBranch/treatments/maleHT.jsx";
import FemaleHairTransplantPune from "../../branchPages/puneBranch/treatments/femaleHT.jsx";
import BeardHairTransplantPune from "../../branchPages/puneBranch/treatments/beardHT.jsx";
import EyebrowHairTransplantPune from "../../branchPages/puneBranch/treatments/eyebrowHT.jsx";
import EyelashHairTransplantPune from "../../branchPages/puneBranch/treatments/eyelashHT.jsx";
import PuneTraining from "../../branchPages/puneBranch/others/punetraining.jsx";
import PuneTestimonials from "../../branchPages/puneBranch/others/punetestimonials.jsx";
import PuneFaqPage from "../../branchPages/puneBranch/others/punefaq.jsx";
import PuneTeamPage from "../../branchPages/puneBranch/others/puneteam.jsx";

function PuneLayout({ children }) {
  return (
    <>
      <PuneNavbar />
      {children}
      <PuneFooter />
    </>
  );
}

const u = (path) => `${SITE_ORIGIN}${path}`;

export default function SiteRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PuneLayout><Pune /></PuneLayout>} />
      <Route path="/pune.php" element={<PuneLayout><PuneBranch url={u("/pune.php")} /></PuneLayout>} />
      <Route path="/description.php" element={<PuneLayout><AboutPune /></PuneLayout>} />
      <Route path="/our-Surgeons.php" element={<PuneLayout><PuneTeamPage url={u("/our-Surgeons.php")} /></PuneLayout>} />
      <Route path="/hair-transplant-in-pune.php" element={<PuneLayout><HairTransplantInIndiaPune /></PuneLayout>} />
      <Route path="/hair-transplant-cost-in-pune.php" element={<PuneLayout><HairTransplantCostPune /></PuneLayout>} />
      <Route path="/hair-transplant-surgery-in-pune.php" element={<PuneLayout><HairTransplantSurgeryPune /></PuneLayout>} />
      <Route path="/about-hair-transplants.php" element={<PuneLayout><AboutHairTransplantPune url={u("/about-hair-transplants.php")} /></PuneLayout>} />
      <Route path="/male-hair-transplants.php" element={<PuneLayout><MaleHairTransplantPune url={u("/male-hair-transplants.php")} /></PuneLayout>} />
      <Route path="/female-hair-transplants.php" element={<PuneLayout><FemaleHairTransplantPune url={u("/female-hair-transplants.php")} /></PuneLayout>} />
      <Route path="/beard-hair-transplants.php" element={<PuneLayout><BeardHairTransplantPune url={u("/beard-hair-transplants.php")} /></PuneLayout>} />
      <Route path="/eyebrow-hair-transplants.php" element={<PuneLayout><EyebrowHairTransplantPune url={u("/eyebrow-hair-transplants.php")} /></PuneLayout>} />
      <Route path="/eyelash-hair-transplants.php" element={<PuneLayout><EyelashHairTransplantPune url={u("/eyelash-hair-transplants.php")} /></PuneLayout>} />
      <Route path="/trainings.php" element={<PuneLayout><PuneTraining url={u("/trainings.php")} /></PuneLayout>} />
      <Route path="/client-testimonials.php" element={<PuneLayout><PuneTestimonials url={u("/client-testimonials.php")} /></PuneLayout>} />
      <Route path="/faq.php" element={<PuneLayout><PuneFaqPage url={u("/faq.php")} /></PuneLayout>} />
    </Routes>
  );
}